// extracted by mini-css-extract-plugin
module.exports = {"content":"indexStyles-module--content--2uI5I"};